import React, { type ErrorInfo } from 'react';

export interface BaseErrorBoundaryProps {
	/** React component to be wrapped */
	children: React.ReactNode;
	ErrorComponent?: React.ComponentType;
	onError?: (error: Error, info?: ErrorInfo) => void;
}

export type BaseErrorBoundaryState = {
	hasError: boolean;
};

export class BaseErrorBoundary extends React.Component<
	BaseErrorBoundaryProps,
	BaseErrorBoundaryState
> {
	state = { hasError: false };

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	componentDidCatch(error: Error, info: ErrorInfo): void {
		this.props.onError?.(error, info);
	}

	render() {
		const { children, ErrorComponent } = this.props;
		const { hasError } = this.state;

		if (hasError) {
			return ErrorComponent ? <ErrorComponent /> : null;
		}

		return children;
	}
}
